var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.icon)?_c('div',{domProps:{"innerHTML":_vm._s(require(`!html-loader!../assets/images/${_vm.icon}.svg`))}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }